'use client';
import React from 'react';
import Link from 'next/link';
import AldarLogo from '@components/AldarLogo';
import GardeniaLogo from '../GardeniaLogo';
import cn from './style.module.scss';

export default function GardeniaLaunchFooter(props: any) {
  const { t } = props;
  return (
    <footer className={cn.launchGardeniaFooter}>
      <div className={cn.launchGardeniaInner}>
        <div className={cn.launchGardeniaContact}>
          <p> {t['yasFooterContact']}</p>
          <p>{t['yasFooterCall']}</p>
          <p>{t['yasFooterPhone']}</p>
          <p>{t['yasFooterDeveloped']}</p>
        </div>
        <div className={cn.launchGardeniaCompany}>
          <span className={cn.launchGardeniaCompany__element}>
            <GardeniaLogo logoImage={props.logoImage} />
          </span>
        </div>
        <div className={cn.launchGardeniaBrand}>
          <Link
            className={cn.launchGardeniaLink}
            href="https://www.aldar.com/properties/en"
            target="_blank" rel="noopener noreferrer"
          >
            <AldarLogo />
          </Link>
        </div>
      </div>
    </footer>
  );
}
